import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import Api from '../../../../_helpers/Api'
import loader from '../../../../assets/img/loader.svg'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import GroupedBarChart from '../../../partials/GroupedBarChart'
import { getPaletteColor } from '../../../partials/chartTheme'

let timeout

function Index(props) {

    const params = useParams()
    const location = useLocation()
    const history = useHistory()

    const searchParams = new URLSearchParams(location.search)

    const [state, setState] = useState({
        filter: {

        },
        setFilter: false,
        update: false,
    })

    const [reservations, setReservations] = useState({
        loading: true,
        data: {},
    })

    const [incomes, setIncomes] = useState({
        loading: true,
        data: {},
    })

    useEffect(() => {
        setState(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    // useEffect(() => {
    //     console.log(state.filter);
    // }, [state.filter]);

    useEffect(() => {
        if (state.setFilter) {
            Object.entries(state.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            let url = '?' + searchParams.toString()

            history.push(url)
        }

    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadReservations()
            loadIncomes()
        }
    }, [state.update])

    const loadReservations = () => {

        setReservations(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'contractors/stats/reservations' + '?id=' + params.id

        Object.entries(state.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {

                setReservations(prev => ({
                    ...prev,
                    data: res.data,
                }))
            })
            .finally(() => {
                setReservations(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const loadIncomes = () => {

        setIncomes(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'contractors/stats/incomes' + '?id=' + params.id

        Object.entries(state.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {

                setIncomes(prev => ({
                    ...prev,
                    data: res.data,
                }))
            })
            .finally(() => {
                setIncomes(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const refreshData = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    //Search
    const handleSearch = (key, val) => {
        clearTimeout(timeout)

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
            page: 1,
        }))

        timeout = setTimeout(() => {
            setState(prev => ({
                ...prev,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }

    const style = {
        padding: '10px',
        background: '#fff'
    }

    const renderChart = (title, subtitle, name, dates = [], colorIndex = 0, valueFormatter) => (
        <>
            <div style={{ marginBottom: '10px' }}>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 500, color: '#1e293b' }}>
                    {title}
                </h3>
                <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#64748b' }}>
                    {subtitle}
                </p>
            </div>
            <GroupedBarChart
                labels={dates.map(d => d.label)}
                series={[
                    {
                        name,
                        color1: getPaletteColor(colorIndex).color1,
                        color2: getPaletteColor(colorIndex).color2,
                        data: dates.map(d => Number(d.total) || 0),
                        valueFormatter,
                    }
                ]}
                roundedBottom
            />
        </>
    )

    return (
        <div className='pannel'>
            <div className="row">
                <div className="col" style={style}>
                    {reservations.loading
                        ?
                        <Skeleton height={400} />
                        :
                        renderChart(
                            trans('random.reservationsCount'),
                            trans('random.forLastYear'),
                            trans('tabs.reservations'),
                            reservations.data.dates,
                            0
                        )
                    }

                </div>
                <div className="col" style={style}>
                    {incomes.loading
                        ?
                        <Skeleton height={400} />
                        :
                        renderChart(
                            trans('headings.incomes'),
                            trans('random.forLastYear') + ` ${incomes.data.currency || ''}`,
                            trans('random.income'),
                            incomes.data.dates,
                            1,
                            val => Number(val).toLocaleString()
                        )
                    }
                </div>
            </div>


        </div>
    )
}

export default Index
